var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1602,
    y: 23.6426,
    width: 8.34877,
    height: 7.99106,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 20.0553C18.8008 19.189 19.1449 18.3583 19.7574 17.7457C20.37 17.1332 21.2008 16.7891 22.067 16.7891H25.8384C26.2675 16.789 26.6924 16.8735 27.0888 17.0377C27.4852 17.2019 27.8454 17.4426 28.1488 17.7461L30.9087 20.506C31.2122 20.8094 31.4529 21.1696 31.6171 21.566C31.7813 21.9624 31.8658 22.3873 31.8658 22.8164V30.9428C31.8658 31.809 31.5216 32.6398 30.9091 33.2524C30.2966 33.8649 29.4658 34.209 28.5995 34.209H22.067C21.2008 34.209 20.37 33.8649 19.7574 33.2524C19.1449 32.6398 18.8008 31.809 18.8008 30.9428V20.0553ZM22.067 26.0434V26.5878H25.3333V24.4103H23.7001C23.267 24.4103 22.8516 24.5824 22.5454 24.8886C22.2391 25.1949 22.067 25.6103 22.067 26.0434ZM22.067 27.6765V29.3097C22.067 29.7428 22.2391 30.1582 22.5454 30.4645C22.8516 30.7707 23.267 30.9428 23.7001 30.9428H25.3333V27.6765H22.067ZM26.9664 30.9428C27.3995 30.9428 27.8149 30.7707 28.1212 30.4645C28.4275 30.1582 28.5995 29.7428 28.5995 29.3097V26.0434C28.5995 25.6103 28.4275 25.1949 28.1212 24.8886C27.8149 24.5824 27.3995 24.4103 26.9664 24.4103H26.422V30.9428H26.9664Z",
    fill: "url(#paint0_linear_722_6519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6519",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6519",
    x1: 18.8008,
    y1: 25.499,
    x2: 31.8658,
    y2: 25.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPark);
export default __webpack_public_path__ + "static/media/ico-park.025bfa1784605255e808672656af7c6d.svg";
export { ForwardRef as ReactComponent };